(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["referrer-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    // ─── Partner site configuration ───────────────────────────────────────────
    // Add or edit entries here when partner sites change.
    // Key must match the `?ref=` value used in the partner site's links.
    var REFERRER_MAP = {
      'smallhope':  { label: 'Small Hope',              url: 'https://www.smallhope.com/' },
      'foundation': { label: 'Small Hope Bay Foundation', url: 'https://smallhopebayfoundation.org/' }
    };
    // ─────────────────────────────────────────────────────────────────────────

    var STORAGE_KEY = 'androsia_referrer';

    function getHeader() {
      return document.querySelector('header');
    }

    function getBannerHeight() {
      var banner = document.querySelector('[data-referrer-banner]');
      return banner ? banner.offsetHeight : 0;
    }

    function applyHeaderOffset(px) {
      var header = getHeader();
      if (header) header.style.top = px > 0 ? px + 'px' : '';
    }

    function showBanner(key) {
      var site = REFERRER_MAP[key];
      if (!site) return;

      var banner  = document.querySelector('[data-referrer-banner]');
      var link    = document.querySelector('[data-referrer-link]');
      var label   = document.querySelector('[data-referrer-label]');

      if (!banner || !link || !label) return;

      link.href        = site.url;
      label.textContent = site.label;

      banner.classList.add('is-visible');
      banner.setAttribute('aria-hidden', 'false');

      // Shift header down after the banner has been painted
      requestAnimationFrame(function () {
        applyHeaderOffset(getBannerHeight());
      });
    }

    function hideBanner() {
      var banner = document.querySelector('[data-referrer-banner]');
      if (!banner) return;

      banner.classList.remove('is-visible');
      banner.setAttribute('aria-hidden', 'true');
      applyHeaderOffset(0);
      localStorage.removeItem(STORAGE_KEY);
    }

    function init() {
      // Read ?ref= from the URL
      var params = new URLSearchParams(window.location.search);
      var ref    = params.get('ref');

      if (ref && REFERRER_MAP[ref]) {
        localStorage.setItem(STORAGE_KEY, ref);

        // Remove ?ref= from the address bar (keeps URL clean)
        params.delete('ref');
        var cleanSearch = params.toString();
        var cleanUrl    = window.location.pathname + (cleanSearch ? '?' + cleanSearch : '') + window.location.hash;
        history.replaceState(null, '', cleanUrl);
      }

      // Show banner if a referrer is stored
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored && REFERRER_MAP[stored]) {
        showBanner(stored);
      }

      // Dismiss button
      var dismissBtn = document.querySelector('[data-referrer-dismiss]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', hideBanner);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
